import * as React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { isSitePath } from '@lib/helpers/site-paths'
import { safeRedirectPath } from '@lib/helpers/safe-redirect'
import { homePathFor } from '@/auth/access'
import { useAuth } from '@/auth/AuthContext'

/**
 * Back to the public site after signing in (docs/public-site.spec.md, "Asking to
 * serve a venue from its page"), only ever to one of the site's own pages, and
 * otherwise home. Whoever signed in goes back, not only a vendor: the site
 * can't tell who holds a lapsed session, so staff can follow the link too, and
 * the page they return to then shows nothing meant for vendors. A full load,
 * since the site isn't part of this app.
 */
export function ContinueToSite() {
  const { user } = useAuth()
  const [params] = useSearchParams()
  const to = safeRedirectPath(params.get('to'))
  const going = to !== null && isSitePath(new URL(to, window.location.origin).pathname)
  React.useEffect(() => {
    if (going && to !== null) window.location.replace(to)
  }, [going, to])
  if (going) return null
  return <Navigate to={homePathFor(user)} replace />
}
